const state = {
  invalidInputError: {
    title: "A required field is missing or a field is invalid.",
    message: "Please review the form for error messages!"
  },
  missingReferenceError: {
    title: "Please add references!",
    message: "You must have at least 3 references."
  },
  invalidImageFileError: {
    title: "Sorry, that file type is invalid!",
    message: "Please upload a PNG or JPG image."
  },
  invalidResumeFileError: {
    title: "Sorry, that file type is invalid!",
    message: "Please upload a DOC or DOCX or PDF file."
  },
  missingResumeError: {
    title: "Your professional childcare resume is missing",
    message: "Please upload your professional childcare resume"
  },
  missingProfilePictureError: {
    title: "Your profile picture is missing",
    message: "Please upload a recent photo of yourself!"
  },
  submitSuccess: {
    title: "Thank you for your application to join the Tiny Treasures Family!",
    message:
      "We will carefully review your application and get in touch with you soon if you seem like a good fit for our team! Because of the high volume of applications we receive we can only respond to the nannies we select. Thanks for your understanding! You can now safely close this window."
  },
  submitSuccessFamilyForm: {
    title: "Thank you for submitting your application!",
    message: "We will review and get in touch with you shortly!"
  },
  submitReferenceError: {
    title: "Your application has been submitted! BUT",
    message:
      "There was an error processing your references. Can you please email them to pinknannies@gmail.com? Thanks!"
  },
  submitChildrenError: {
    title: "Your application has been submitted! BUT",
    message:
      "There was an error processing your children information. Can you please email them to pinknannies@gmail.com? Thanks!"
  },
  submitError: {
    title: "Failed to submit your application",
    message: "There was an error processing your application"
  },
  updateProfessionalInfoError: {
    title: "Failed to update professional information",
    message: "There was an error updating professional information"
  },
  deleteReferenceConfirmDialog: {
    message: "Are you sure you want to delete this reference?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  },
  deleteChildrenConfirmDialog: {
    message: "Are you sure you want to delete this child?",
    acceptLabel: "Delete",
    rejectLabel: "Cancel"
  }
};

const mutations = {};

const actions = {};

const getters = {
  invalidInputError(state) {
    return state.invalidInputError;
  },
  missingReferenceError(state) {
    return state.missingReferenceError;
  },
  invalidImageFileError(state) {
    return state.invalidImageFileError;
  },
  missingResumeError(state) {
    return state.missingResumeError;
  },
  missingProfilePictureError(state) {
    return state.missingProfilePictureError;
  },
  submitReferenceError(state) {
    return state.submitReferenceError;
  },
  submitSuccess(state) {
    return state.submitSuccess;
  },
  submitError(state) {
    return state.submitError;
  },
  deleteReferenceConfirmDialog(state) {
    return state.deleteReferenceConfirmDialog;
  },
  submitSuccessFamilyForm(state) {
    return state.submitSuccessFamilyForm;
  },
  deleteChildrenConfirmDialog(state) {
    return state.deleteChildrenConfirmDialog;
  },
  invalidResumeFileError(state) {
    return state.invalidResumeFileError;
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};



// WEBPACK FOOTER //
// ./src/store/modules/dialogContent.js